import React from 'react'
import { Route } from 'react-router-dom'
import Meta from '../meta'
import Page from '../page'
import HtmlTagClassName from '../html-tag-class-name'

const Default = (props) => {
  return (
    <Route
      exact={props.exact}
      path={props.path}
      render={() => {
        return (
          <React.Fragment>
            <HtmlTagClassName
              className={props.htmlTagClassName}
            />
            <Meta
        			canonicalUrlPathname={props.location.pathname}
        			description={props.metaDescription}
        			title={props.pageTitle}
        		/>
            <Page
              content={props.content}
          		pathname={props.location.pathname}
            />
          </React.Fragment>
        )
      }}
    />
  )
}

Default.defaultProps = {
  className: '',
  exact: false,
  metaDescription: '',
  pageTitle: '',
  path: '',
}

export default Default



// WEBPACK FOOTER //
// ./src/common/components/route-with-auth/default.js